import React, { useContext, useEffect, useState } from "react";
import HButton from "../custom/input/button/Button";
import useHttp from "../../hooks/useHttp";
import { AppContext } from "../../context/AppContext";
import { Dropdown, Progress } from "antd";
import { useNavigate } from "react-router-dom";

const AiCreditsHeaderControls = () => {
    const [remainingAiCredits, setRemainingAiCredits] = useState(0);
    const [overallAiCredits, setOverallAiCredits] = useState(0);
    const { fetchData } = useHttp();
    const [appProperties] = useContext(AppContext);
    const [, setOpenAiCreditsModal] = useState(false);
    const navigate = useNavigate();
    const fetchRemainingAiCredits = async () => {
        try {
            const response = await fetchData('ai/credits', 'GET', null, appProperties);
            const data = await JSON.parse(response);
            setRemainingAiCredits(data?.data?.remainingCreditsTotal);
            setOverallAiCredits(data?.data?.overallCreditsPurchased);
        } catch (error) {
            console.error('Error fetching remaining AI credits:', error);
        }
    }
    useEffect(() => {
        fetchRemainingAiCredits();
    }, [fetchData, appProperties]);

    const handleClick = () => {
        setOpenAiCreditsModal(true);
    }   

    const handleViewUsageDetails = () => {
        navigate('/settings/ai/credits' + window.location.search);
    };

    const creditPanel = (
        <div className="d-flex flex-column gap-2 hs-w-400-px">
        <div className="hs-fs-16 hs-fw-600">Credits</div>
        <div className="d-flex justify-content-between">
            <div className="hs-fs-14 hs-fw-400">Credits remaining</div>
            <div>{remainingAiCredits}/{overallAiCredits}</div>
        </div>
        <div>
        <Progress percent={(remainingAiCredits/overallAiCredits)*100} showInfo={false} strokeColor="var(--hs-violet)" />

        </div>
        <div className="d-flex justify-content-end gap-2">
            <HButton variant="cancel" size="s" onClick={handleViewUsageDetails}>View Usage Details</HButton>
            <HButton variant="" size="s">Add More Credits</HButton>
        </div>
        </div>
    )
  return (
    <div>
        <Dropdown
        rootClassName="ai-credits-header-dropdown"
            menu={{
                items: [
                    {
                        label: creditPanel,
                        key: "ai-credits",
                        onClick: handleClick,
                    }
                ]
            }}
            placement="bottomLeft"
            arrow
            
        >
            <span className="ai-credits-header-controls__dropdown-trigger">
                <HButton variant="borderless" size="m" type="borderless" prefixIcon={<div className="actionIconsSprite-2 credits-Icon-violet"></div>}>
                    {remainingAiCredits}
                </HButton>
            </span>
        </Dropdown>

      
    </div>
  )
}
export default AiCreditsHeaderControls
